import React, { useState, useEffect } from 'react';
import Button from '@ids/button';
import Dropdown, { MenuItem } from '@ids-ts/dropdown';
import { useDispatch, useSelector } from 'react-redux';
import InlineMessage from '@ids-beta/inline-message';
import { addToCartPut } from '../../services/checkoutDataService';
import { ReduxEvent } from '../../../assets/pagedata/constant';
import Loader from '../Common/Loader';
import { convertToSnakeCase, isProductOutOfStock } from '../Util/CommonUtils';

export const AddToCartXsellPricing = (props) => {
  const { outOfStockItems = [] } = props;
  const [cartSuccess, setCartSuccess] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [quantityValue, setQuantityValues] = useState(null);
  const [outOfStockSingleSku, setOutOfStockSingleSku] = useState(null);

  const mainReducer = useSelector((state) => state.mainReducer);
  const productSku =
    props.skuList && props.skuList[0] && props.skuList[0][0] && props.skuList[0][0].Sku;


  const dispatch = useDispatch();

  const handleSingleSkuOutOfStock = (sku) => {
    if (sku && sku.length > 0) {
      const outOfStockStatusSku = isProductOutOfStock(
        {
          pfid: null,
          sku,
        },
        outOfStockItems,
      );
      setOutOfStockSingleSku(outOfStockStatusSku);
    }
  };

  useEffect(() => {
    setQuantityValues(productSku);
    handleSingleSkuOutOfStock(productSku);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productSku, outOfStockItems]);

  const isBundleProduct = (pid) => {
    return !!(pid === 'BUNDLE-01' || pid === 'BUNDLE-03');
  };

  const addToCartSuccess = (pageInfo) => {
    props.logToIMWebLogger('info', `XsellPage -> AddToCartXsellPricing: handleAddToCart success`);
    dispatch({
      type: ReduxEvent.PAGE_DATA,
      data: {
        pageData: {
          cartCount: pageInfo.CartCount,
          login: pageInfo.login,
          promotionMessage: pageInfo.PromotionMessage,
        },
      },
    });
    const linkData = {
      linkName: 'cartadd',
      aryProducts: [[props.pfid]],
      eventList: 'cartadd',
    };
    props.logToAnalytics({ linkData }, 'link');
    if (props.cartXsellCallBack) {
      props.cartXsellCallBack();
    } else {
      setCartSuccess(true);
    }
    setShowLoader(false);
  };

  const addToCartFailed = (err) => {
    props.logToIMWebLogger(
      'error',
      `XsellPage -> AddToCartXsellPricing: handleAddToCart failed. Reason: ${err}`,
    );

    props.displayToast('Some error occured. Please try again.');
    setShowLoader(false);
    setCartSuccess(false);
  };

  const handleAddToCart = () => {
    props.logToIMWebLogger('info', `XsellPage -> AddToCartXsellPricing: handleAddToCart called`);

    setShowLoader(true);

    if (mainReducer.pageData.cartCount >= 30) {
      props.cartLimitExceed();
      setShowLoader(false);
      return;
    }

    if (isBundleProduct(props.pfid)) {
      const params = {
        IsCustomizable: props.product.Products[0].IsCustomizable,
        PfId: props.pfid,
        SKU: props.bundleSku,
        ImprintId: props.product.Products[0].ImprintId,
      };
      const hadQueryParam = true;
      addToCartPut(params, addToCartSuccess, addToCartFailed, hadQueryParam);
    } else {
      const params = {
        IsCustomizable: '0',
        PfId: props.pfid,
        SKU: quantityValue,
      };
      addToCartPut(params, addToCartSuccess, addToCartFailed);
    }
  };

  const formatPrice = (val) => {
    const price = val.split('.', 2);
    return (
      <span>
        {price[0]} <sup className="xsell-sup-price">{price[1]}</sup>
      </span>
    );
  };

  const getProductDescription = () => {
    const skuListObject = props.skuList && props.skuList.length && props.skuList[0];
    let price = '';
    let bundleArray = [];

    if (skuListObject && skuListObject.length && skuListObject[0]) {
      if (isBundleProduct && props.bundleSku) {
        bundleArray = skuListObject.filter((bundleItem) => {
          return bundleItem.Sku === props.bundleSku;
        });
      }

      if (bundleArray && bundleArray.length) {
        price = bundleArray[0].DiscPrice ? bundleArray[0].DiscPrice : bundleArray[0].ListPrice;
      } else {
        price = skuListObject[0].DiscPrice
          ? skuListObject[0].DiscPrice
          : skuListObject[0].ListPrice;
      }

      return (
        <span>
          1 pack for <span className="xsell-price">{formatPrice(price)}</span>
        </span>
      );
    }
  };

  const getQuantityDropDownList = () => {
    const skuListObject = props.skuList && props.skuList.length && props.skuList[0];
    if (skuListObject && skuListObject.length) {
      return skuListObject;
    }
  };

  const productsWithNoQuantityDropdown = ['BUNDLE-01', 'BUNDLE-03', 'SSTAMP-01', 'SPEN-01'];

  const getDisplayQuantityDropDown = (proId) => {
    return !(productsWithNoQuantityDropdown.indexOf(proId) > -1);
  };

  const handleQuantityChange = (e) => {
    setQuantityValues(e.target.value);
    handleSingleSkuOutOfStock(e.target.value);
  };

  return (
    <div>
      <Loader show={showLoader} size={80} loadingText="Please wait..." />
      <div className="xsell-label">Quantity</div>
      {!getDisplayQuantityDropDown(props.pfid) && (
        <>
          <div className="xsell-atc-promo">{getProductDescription()}</div>
          {!isBundleProduct(props.pfid) && (
            <div className="xsell-price-sub-text">
              <i>1 pack contains 5 pens</i>
            </div>
          )}
        </>
      )}
      {getDisplayQuantityDropDown(props.pfid) && (
        <Dropdown
          role="option"
          theme="quickbooks"
          value={quantityValue}
          aria-label="XsellDropdown"
          onChange={handleQuantityChange}
          className="xsell-dropDown dropdown-background-color-white"
          disabled={cartSuccess}
        >
          {getQuantityDropDownList() &&
            getQuantityDropDownList().map((q, key) => {
              return (
                <MenuItem key={`${key}`} value={`${q.Sku}`}>{`${q.Quantity} for ${
                  q.DiscPrice ? q.DiscPrice : q.ListPrice
                }`}</MenuItem>
              );
            })}
        </Dropdown>
      )}
      {outOfStockSingleSku?.displayOutOfStock ? (
        <div className="product-unavailable-msg margin-bottom-20">
          {outOfStockSingleSku.outOfStockMessage}
        </div>
      ) : (
        <Button
          theme="quickbooks"
          buttonType="secondary"
          className="xsell-button"
          onClick={() => {
            handleAddToCart();
          }}
          disabled={cartSuccess}
          data-wa-link="Add to cart xsell"
          data-ui-object="button"
          data-refer-ui-access-point={`add_to_cart_xsell| ${convertToSnakeCase(
            props.product.Name,
          )}`}
        >
          Add to Cart
        </Button>
      )}
      <InlineMessage
        isStatic
        open={cartSuccess}
        className="added-msg"
        content={<div>Added to Cart</div>}
      />
    </div>
  );
};
